interface EmptyStateProps {
  title: string
  description?: string
}

export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center px-4 text-center">
      <p className="text-sm font-medium text-(--color-text-secondary)">{title}</p>
      {description && (
        <p className="mt-1 text-xs text-(--color-text-muted)">{description}</p>
      )}
    </div>
  )
}
